import(/* webpackMode: "eager", webpackExports: ["ShopEmbed"] */ "/home/pubky/cicd/actions-runner/_work/pubky-stack/pubky-stack/pubky-app/src/components/organisms/ShopEmbed/ShopEmbed.tsx");
